import type { CSSProperties } from 'react';

/** Official IF shield, drawn as a vector so it stays sharp at any size. */

const NAVY = '#043370';
const WHITE = '#ffffff';

type IfShieldProps = {
  className?: string;
  color?: string;
  title?: string;
  style?: CSSProperties;
};

export default function IfShield({ className = '', color, title, style }: IfShieldProps) {
  const fill = color ?? 'currentColor';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="240 368 516 576"
      className={`block ${className}`.trim()}
      style={style}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <path
        fill={fill}
        fillRule="evenodd"
        d="M497.98 376.64 L251.61 433.97 V690.9 c0 63.49 33.88 122.14 88.86 153.85 L497.98 935.66 l157.51-90.91 c55-31.74 88.87-90.39 88.87-153.85 V433.97 Z M497.98 401.74 L719.91 453.38 V690.9 c0 54.57-29.36 105.42-76.64 132.69 L497.98 907.44 352.69 823.59 C305.41 796.3 276.05 745.47 276.05 690.9 V453.38 Z"
      />
      <path
        fill={fill}
        transform="translate(344.62024 793.935696)"
        d="M101.203125-336.671875V0H24.484375v-336.671875Z"
      />
      <path
        fill={fill}
        transform="translate(431.920526 793.935696)"
        d="M219.140625-336.671875V-269.34375H101.203125v66.921875H210.171875v67.34375H101.203125V0H24.484375v-336.671875Z"
      />
    </svg>
  );
}

export const IF_SHIELD_NAVY = NAVY;
export const IF_SHIELD_WHITE = WHITE;
